import { cybsColors, vaultColors } from './variables';

// Variables with these names should never be affected by theming
export const keysToIgnore: string[] = [
  'accent',
  'applicationBackground',
  'badgeAccentFill',
  'badgeAccentLabel',
  'badgeCriticalFill',
  'badgeCriticalLabel',
  'badgeDisabledFill',
  'badgeDisabledLabel',
  'badgeStableFill',
  'badgeStableLabel',
  'badgeStatusFill',
  'badgeStatusLabel',
  'badgeWarningFill',
  'badgeWarningLabel',
  'footerBackground',
  'inputLabelError',
  'linkInlineUnderline',
  'linkUnderline',
  'linkUnderlineFocus',
  'linkUnderlineHover',
  'linkUnderlineUnderline',
  'navLinkMarketingActiveBorder',
  'notificationAlertPadding',
  'notificationError',
  'notificationErrorLight',
  'notificationForegroundDark',
  'notificationForegroundLight',
  'notificationInformation',
  'notificationInformationLight',
  'notificationSuccess',
  'notificationSuccessLight',
  'notificationWarning',
  'notificationWarningLight',
  'progressAccent',
  'progressGaugeBackgroundApproved',
  'progressGaugeRingApproved',
  'progressGaugeTextApproved',
  'statusApproved',
  'tableAlt',
  'transparent',
  'wizardCompletedBackground',
  'wizardCompletedBorder',
  'wizardErrorBorder',
  'wizardErrorForeground'
];

// Variables with these color values should never be affected by theming
export const valuesToIgnore: string[] = [
  cybsColors.moon,
  cybsColors.lightGray,
  cybsColors.mediumGray,
  cybsColors.gray,
  vaultColors.gray,
  vaultColors.lead,
  vaultColors.white,
  vaultColors.green,
  vaultColors.orange,
  vaultColors.red
];
